<template>
  <v-sheet :width="'100%'" :elevation="4">
    <v-container>
      <div class="client-block">
        <v-row>
          <v-col cols="8">
            <h3 class="text-h3 client-block__agent">{{ lead.fullname }}</h3>
          </v-col>
          <v-col cols="4">
            <p
                class="client-block__policy-number"
                v-if="lead.policy_number"
            >
              Policy Number:
              <span class="font-weight-bold green--text">{{ lead.policy_number }}</span>
            </p>
            <p class="client-block__info-item" v-if="lead.draft_date">
              Draft Date:
              <span>{{ lead.draft_date }}</span>
            </p>
            <p class="client-block__info-item" v-if="lead.app_date">
              Submit Date:
              <span>{{ lead.app_date }}</span>
            </p>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="3" v-if="lead.type_id === 2">
            <ul class="client-block__price-list" v-if="lead.price">
              <li v-for="(item, index) in lead.price" :key="index">
                <v-radio-group
                  v-on:change="selectedPremiumCarrierHandler"
                  v-model="selectedPrice"
                >
                  <div v-if="index != 'american_general'">
                    <span class="d-flex">
                      $
                      <v-text-field
                          class="client-block__price-input"
                          v-model="lead.price[index]"
                          :readonly="!selectedPrice"
                          :class="{ 'client-block__invalid-price': invalidPrices.includes(index) }"
                          @input="updatePrice"
                      ></v-text-field>
                    </span>
                    <v-radio
                      class="client-block__company"
                      :label="index.split('_').join(' ')"
                      :key="index"
                      :value="index"
                    ></v-radio>
                  </div>
                  <div
                    v-else-if="
                      index == 'american_general' && lead.rate_class == 'gi'
                    "
                  >
                    <span class="d-flex">
                      $
                      <v-text-field
                          class="client-block__price-input"
                          v-model="lead.price[index]"
                          :readonly="!lead.post_sale"
                          :class="{ 'client-block__invalid-price': invalidPrices.includes(index) }"
                          @input="updatePrice"
                      ></v-text-field>
                    </span>
                    <v-radio
                      class="client-block__company"
                      :label="index.split('_').join(' ')"
                      :key="index"
                      :value="index"
                    ></v-radio>
                  </div>
                </v-radio-group>
              </li>
            </ul>
          </v-col>
          <v-col cols="5">
            <ul class="client-block__info-list">
              <li class="client-block__info-item" v-if="lead.zip">
                Zip code:
                <span>{{ lead.zip }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.county">
                Country:
                <span>{{ lead.county }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.city">
                City:
                <span>{{ lead.city }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.contact">
                Contact name:
                <span>{{ lead.contact }}</span>
              </li>
              <li class="client-block__info-item" v-if="showPhoneNumber">
                Phone:
                <span>{{ lead.phone }}</span>
              </li>
              <li class="client-block__info-item" v-if="showSecondPhoneNumber">
                Second Phone:
                <span>{{ lead.second_phone }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.email">
                Email:
                <span>{{ lead.email }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.gender">
                Gender:
                <span>{{
                  lead.gender.toLowerCase() === "m" ? "Male" : "Female"
                }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.state">
                State:
                <span>
                  {{ lead.state }}
                  ({{
                    baseData.states[
                      baseData.states.findIndex(
                        (data) => lead.state === data.code
                      )
                    ].name
                  }})
                </span>
              </li>
              <li class="client-block__info-item" v-if="lead.address">
                Address:
                <span>{{ lead.address }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.address_2">
                Address 2:
                <span>{{ lead.address_2 }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.city">
                City:
                <span>{{ lead.city }}</span>
              </li>
              <li
                class="client-block__info-item"
                v-if="
                  lead.birth_month != null &&
                  lead.birth_year != null &&
                  lead.birth_day != null
                "
              >
                DOB:
                <span
                  >{{ lead.birth_month }}/{{ lead.birth_day }}/{{
                    lead.birth_year
                  }}</span
                >
              </li>
              <li class="client-block__info-item" v-if="lead.primary">
                Birth date:
                <span>{{ lead.primary.birth_date }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.primary">
                Height:
                <span>{{ lead.primary.height }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.primary">
                Weight:
                <span>{{ lead.primary.height }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.age != null">
                Age:
                <span>{{ lead.age }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.bmi != null">
                BMI:
                <span>{{ lead.bmi }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.height">
                Height:
                <span>{{
                  baseData.heights[
                    baseData.heights.findIndex(
                      (data) => lead.height === data.value
                    )
                  ].text
                }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.weight">
                Pounds:
                <span>{{ lead.weight }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.marital_status">
                Marital Status:
                <span>{{ lead.marital_status }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.military">
                Military:
                <span>{{ lead.military == 1 ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.tobacco">
                Tobacco:
                <span>{{ lead.tobacco == true ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.primary">
                Tobacco:
                <span>{{ lead.primary.tobacco == true ? "Yes" : "No" }}</span>
              </li>

              <li class="client-block__info-item" v-if="lead.currently_insured">
                Insured:
                <span>{{ lead.currently_insured == 1 ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.high_risk">
                High Risk:
                <span>{{ lead.high_risk == 1 ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.dui">
                DUI:
                <span>{{ lead.dui == 1 ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.current_company">
                Current Company:
                <span>{{ lead.current_company }}</span>
              </li>
               <li class="client-block__info-item" v-if="lead.company">
                Company:
                <span>{{ lead.company }}</span>
              </li>
              
              <li class="client-block__info-item" v-if="lead.datavendor_id">
                Datavendor ID:
                <span>{{ lead.datavendor_id }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.biz_type">
                Biz. Type:
                <span>{{ lead.biz_type }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.biz_name">
                Biz. Name:
                <span>{{ lead.biz_name }}</span>
              </li>

              <li
                class="client-block__info-item"
                v-if="lead.weekly_exercise_hours"
              >
                Weekly Exercise Hours:
                <span>{{ lead.weekly_exercise_hours }}</span>
              </li>
              <li
                class="client-block__info-item"
                v-if="lead.prescription_medications"
              >
                Prescription Medications:
                <span>{{
                  lead.prescription_medications
                }}</span>
              </li>
<!--              <li class="client-block__info-item" v-if="lead.medications">-->
<!--                Disease:-->
<!--                <span-->
<!--                  v-for="(medication, index) in lead.medications"-->
<!--                  :key="medication"-->
<!--                >-->
<!--                  <template v-if="index == 0">{{-->
<!--                    baseData.mediaalphaMedications[medication - 1].name-->
<!--                  }}</template>-->
<!--                  <template v-else-->
<!--                    >,-->
<!--                    {{-->
<!--                      baseData.mediaalphaMedications[medication - 1].name-->
<!--                    }}</template-->
<!--                  >-->
<!--                </span>-->
<!--              </li>-->
            </ul>
          </v-col>
          <v-col cols="6" v-if="lead.type_id === 4">
            <ul class="client-block__info-list">
              <li class="client-block__info-item" v-if="lead.credit_rating">
                Credit Rating:
                <span>{{ lead.credit_rating }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.coverage_type">
                Coverage Type:
                <span>{{ lead.coverage_type }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.household_income">
                Household Income:
                <span>${{ lead.household_income }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.pregnant">
                Pregnant:
                <span>{{ lead.pregnant == true ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.treated">
                Treated:
                <span>{{ lead.treated == true ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.hospitalized">
                Hospitalized:
                <span>{{ lead.hospitalized == true ? "Yes" : "No" }}</span>
              </li>
              <li class="client-block__info-item" v-if="lead.self_employed">
                Self Employed:
                <span>{{ lead.self_employed == true ? "Yes" : "No" }}</span>
              </li>
            </ul>
          </v-col>
          <v-col cols="4">
            <ul class="client-block__info-list">
              <li class="client-block__info-item" v-if="lead.term">
                Product Type:
                <span>{{
                  baseData.terms[
                    baseData.terms.findIndex((data) => lead.term == data.code)
                  ].name
                }}</span>
              </li>

              <li class="client-block__info-item" v-if="lead.rate_class">
                Rate Class:
                <span v-if="lead.term !== 'fex'">{{
                  baseData.rateClass[
                    baseData.rateClass.findIndex(
                      (data) => lead.rate_class === data.code
                    )
                  ].name
                }}</span>
                <span v-else>{{
                  baseData.fexRateClass[
                    baseData.fexRateClass.findIndex(
                      (data) => lead.rate_class === data.code
                    )
                  ].name
                }}</span>
              </li>

              <li class="client-block__info-item" v-if="lead.coverage_amount">
                Coverage Amount: <span>${{ lead.coverage_amount }}</span>
              </li>

              <li class="client-block__info-item" v-if="lead.chargeback">
                Chargeback:
                <span>{{ lead.chargeback ? "Yes" : "NO" }}</span>
              </li>
              <li v-if="lead.jobstatus != null" class="client-block__info-item">
                Job Status:
                <span>{{ baseData.jobStatus[lead.jobstatus - 1].name }}</span>
              </li>

              <li class="client-block__info-item" v-if="lead.policy">
                Final Expense:
                <span>{{ lead.policy == 1 ? "Yes" : "No" }}</span>
              </li>
              <li
                v-if="lead.disability != null"
                class="client-block__info-item"
              >
                Funeral Type:
                <span>{{
                  baseData.disabilities[lead.disability - 1].name
                }}</span>
              </li>
              <li
                v-if="lead.total_income != null"
                class="client-block__info-item"
              >
                Total Income:
                <span>{{ lead.total_income }}</span>
              </li>
              <li
                v-if="lead.mortgage_remaining != null"
                class="client-block__info-item"
              >
                Mortgage:
                <span>{{ lead.mortgage == 1 ? "Yes" : "No" }}</span>
              </li>
              <li
                v-if="lead.mortgage_remaining != null"
                class="client-block__info-item"
              >
                Mortgage Remaining:
                <span>{{ lead.mortgage_remaining }}</span>
              </li>
            </ul>
          </v-col>
        </v-row>
        <v-col cols="12" >
          <span v-if="lead.type_id === 2">
            BANK ACCOUNT:
            <span
              v-if="lead.checking_account"
              class="font-weight-bold green--text"
              >Yes</span
            >
            <span v-else class="font-weight-bold red--text">No</span>
          </span>
          <p class="text-subtitle-1">
            Agent:
            <span
              class="font-weight-bold green--text"
              v-if="lead.agent_fullname != null && lead.agent_email != null"
              >{{ lead.agent_fullname }} | {{ lead.agent_email }}</span
            >
            <span v-else class="red--text">not assigned</span>
          </p>
        </v-col>
      </div>
    </v-container>
  </v-sheet>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
  name: "ClientBlockMedialpha",
  inject: ["theme"],
  props: {
    baseData: Object,
  },
  data() {
    return {
      selectedPrice: null,
      invalidPrices: [],
    };
  },
  methods: {
    ...mapActions({
      showHandlerSnackbar: "snackbar/showHandlerSnackbar",
    }),

    ...mapMutations({
      SET_UNCOMPLETED_LEAD: "auth/SET_UNCOMPLETED_LEAD",
    }),

    statusHandler() {
      if (this.lead.status) {
        this.$socket.emit("update-status", this.lead.id, this.lead.status);
        this.SET_UNCOMPLETED_LEAD(null);
      }
    },
    selectedPremiumCarrierHandler() {
      this.$axios.post("/lead/select-carrier", {
        lead_id: this.lead.id,
        carrier: this.selectedPrice,
      });
    },
    updatePrice() {
      let prices = this.lead.price;
      const regex = new RegExp('^\\d{0,4}(\\.\\d{0,4})?$');
      this.invalidPrices = [];

      for (const price in prices) {
        if (!regex.test(prices[price])) {
          this.invalidPrices.push(price);
        }
      }

      if (!this.invalidPrices.length) {
        this.$socket.emit("update-price", this.lead.id, this.lead.price);
        this.selectedPremiumCarrierHandler();
      }
    },
  },
  mounted() {
    this.selectedPrice = this.lead.pc ? Object.keys(JSON.parse(this.lead.pc))[0] : null;
    this.sockets.subscribe("UPDATE_LEAD", () => {
      this.showHandlerSnackbar({
        color: "success",
        text: "Lead updated",
        show: true,
      });
    });
  },
  computed: {
    ...mapGetters({
      lead: "lead/lead",
      user: "auth/user",
      loadingSuitableAgents: "agents/loadingSuitableAgents",
    }),

    showPhoneNumber: {
      get: function () {
        if (
          !this.lead.phone ||
          this.lead.status == "doNotCall" ||
          this.lead.status == "wrongPhoneNumber"
        ) {
          return false;
        }

        return true;
      },
    },
    showSecondPhoneNumber: {
      get: function () {
        if (
          !this.lead.second_phone ||
          this.lead.status == "doNotCall" ||
          this.lead.status == "wrongPhoneNumber"
        ) {
          return false;
        }

        return true;
      },
    },
  },
};
</script>

<style lang="scss">
.client-block {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  &__company,
  &__agent {
    text-transform: capitalize;
  }
  &__price-list {
    list-style: none;
    li {
      text-align: right;
      span {
        display: block;
        font-size: 36px;
        font-weight: bold;
      }
    }
  }

  &__info-item {
    font-weight: bold;
    span {
      color: #1867c0;
      text-decoration: underline;
    }
  }
  &__info-list {
    list-style: none;
    padding: 0 !important;
  }
  &__invalid-price input {
    color: red !important;
  }
  &__policy-number {
    text-align: right;
  }
}
</style>